import React, { useContext, useEffect, useState } from "react";
import { Player } from "../../interfaces/Player.Interface";
import playerImage from "../../img/player_default.png";
import "./PlayerAttendance.Styles.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAmbulance,
  faCheckCircle,
  faExclamationCircle,
  faQuestion,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { DB_REF } from "../../constants/DB";
import { ATTENDANCE_TYPE } from "../../interfaces/Attendance.Type";
import { dateToFirestore } from "../../services/DateToFirestore";

interface Props {
  player: Player;
  date: Date;
}

export default function PlayerAttendanceElement(props: Props) {
  const { player, date } = props;
  const firebase = useContext(firebaseContext);
  const [atType, setAtType] = useState<ATTENDANCE_TYPE | null>(null);

  useEffect(() => {
    firebase
      .firestore()
      .collection(DB_REF.practiceData)
      .where("playerId", "==", player.playerId)
      .where("date", "==", dateToFirestore(date))
      .onSnapshot((col) => {
        if (col.empty) {
          setAtType(null);
        } else {
          setAtType(col.docs[0].data().type);
        }
      });
  }, [firebase]);

  const isActive = (type: ATTENDANCE_TYPE | null) => {
    if (type === atType) {
      return "active";
    } else {
      return "";
    }
  };

  const onClick = async (type: ATTENDANCE_TYPE) => {
    const pDataCol = firebase.firestore().collection(DB_REF.practiceData);

    const existRecord = await pDataCol
      .where("playerId", "==", player.playerId)
      .where("date", "==", dateToFirestore(date))
      .get();

    if (existRecord.empty) {
      pDataCol.add({
        playerId: player.playerId,
        date: dateToFirestore(date),
        type,
      });
    } else {
      existRecord.docs[0].ref.update({ type });
    }
  };

  const onClickQ = async () => {
    const pData = await firebase
      .firestore()
      .collection(DB_REF.practiceData)
      .where("date", "==", dateToFirestore(date))
      .where("playerId", "==", player.playerId)
      .get();

    if (!pData.empty) {
      await pData.docs[0].ref.delete();
    }
  };

  const renderIcons = () => {
    return (
      <div className="icon-holder">
        <div onClick={onClickQ} className={isActive(null)}>
          <FontAwesomeIcon icon={faQuestion} />
        </div>
        <div onClick={() => onClick("present")} className={isActive("present")}>
          <FontAwesomeIcon
            style={{ color: "greenyellow" }}
            icon={faCheckCircle}
          />
        </div>
        <div onClick={() => onClick("absent")} className={isActive("absent")}>
          <FontAwesomeIcon style={{ color: "#e8232d" }} icon={faTimesCircle} />
        </div>
        <div onClick={() => onClick("leave")} className={isActive("leave")}>
          <FontAwesomeIcon
            style={{ color: "cyan" }}
            icon={faExclamationCircle}
          />
        </div>
        <div onClick={() => onClick("injured")} className={isActive("injured")}>
          <FontAwesomeIcon style={{ color: "pink" }} icon={faAmbulance} />
        </div>
      </div>
    );
  };

  return (
    <div className="player-attendance-container">
      <div>
        <img src={player.imageUrl || playerImage} />
      </div>
      <div style={{ flex: 1, paddingLeft: 20 }}>
        {player.firstName} {player.lastName}
      </div>
      <div>{renderIcons()}</div>
    </div>
  );
}
